// Hjelpefunksjon for å konvertere markdown til HTML
export const convertMarkdownToHtml = (text) => {
    if (!text) return '';
    return text
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
      .replace(/\n/g, '<br/>');
  };
  
  export default {
    convertMarkdownToHtml
  };